import { DateInput } from '@framework/form';
import type { IWidgetComponentProps } from '~packages/engine/src/schema/widgets/IWidgetType';
import { RichTextAdvancedRender } from '../../../../../inputs/rich-text-advanced/render/RichTextAdvancedRender';
import { ConfigFormItem } from '../../../../../ui/form/ConfigFormItem';
import { getWidgetProps } from '../common/util/getWidgetProps';
import { getWidgetDateFormat, type IDateWidget } from './IDateWidget';

export interface IDateWidgetComponentProps
  extends IWidgetComponentProps<IDateWidget> {}

export function DateWidgetComponent(props: IDateWidgetComponentProps) {
  const options = getWidgetProps(props);

  const format = getWidgetDateFormat(props.widget);

  return (
    <ConfigFormItem
      name={options.name}
      label={<RichTextAdvancedRender inline text={options.label} />}
      help={<RichTextAdvancedRender inline text={options.helpText} />}
      layout={{ hideVisualLabel: options.hideLabel }}
      readonly={options.readonly}
    >
      <DateInput
        readOnly={props.readonly}
        name={options.name}
        type={format.serializeFormat === 'YYYY-MM-DD' ? 'date' : 'datetime'}
        showTime={format.serializeFormat !== 'YYYY-MM-DD'}
        format={format.datePickerFormat}
        placeholder={options.placeholder ?? format.placeholder}
        value={options.value}
        tabIndex={options.preview ? -1 : undefined}
      />
    </ConfigFormItem>
  );
}
